import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from '_public/templates/main/app.module';

//require('./styles.scss');

if (process.env.ENV === 'production') {
	enableProdMode();
}

const bootstrapContent = () => platformBrowserDynamic().bootstrapModule(AppModule);
bootstrapContent().catch(err => console.log(err));
